"use client";

import { clsx } from "@trydig/ui";
import { useSearchBox } from "react-instantsearch";
import { useAlgoliaAutoCompleteSuggestions, useAlgoliaSearchModal } from "~/features/algolia/hooks";
import styles from "./AutoCompleteSuggestions.module.css";

export const AutoCompleteSuggestions = () => {
	const { query, refine } = useSearchBox();
	const { mode } = useAlgoliaSearchModal();
	const { data: autoCompleteSuggestions, isLoading } = useAlgoliaAutoCompleteSuggestions(query, 6);

	if (
		!query ||
		mode !== "default" ||
		isLoading ||
		!autoCompleteSuggestions ||
		autoCompleteSuggestions.length === 0
	) {
		return null;
	}

	return (
		<div className={styles.root}>
			<p className={clsx(styles.headerText, styles.active)} style={{ marginBottom: "0px" }}>
				Forslag
			</p>
			<div className={styles.suggestions}>
				{autoCompleteSuggestions.map((suggestion, i) => (
					<button
						key={i}
						onClick={() => {
							refine(suggestion);
						}}
						className={styles.suggestion}
					>
						{suggestion.charAt(0).toUpperCase() + suggestion.slice(1)}
					</button>
				))}
			</div>
		</div>
	);
};
